import numeral from 'numeral';

import { LOCALE_DATA } from '../config/numeral';

LOCALE_DATA.forEach(({ code, locale }) => numeral.register('locale', code, locale));
